import { Link } from 'react-router-dom';
import Navbar from '../../home/components/Navbar';
import Footer from '../../home/components/Footer';

interface LegalSection {
  title: string;
  items?: string[];
  body?: string;
}

interface LegalLayoutProps {
  title: string;
  subtitle?: string;
  lastUpdated?: string;
  sections: LegalSection[];
}

export default function LegalLayout({ title, subtitle, lastUpdated, sections }: LegalLayoutProps) {
  return (
    <div className="min-h-screen bg-[#FAF7F4]">
      <Navbar />

      {/* Hero */}
      <div className="bg-[#F0EBE3] pt-28 pb-12">
        <div className="max-w-3xl mx-auto px-6 text-center">
          <nav className="flex items-center justify-center gap-2 text-xs text-[#A0A0A0] mb-4">
            <Link to="/" className="hover:text-[#8FA882] transition-colors cursor-pointer">ホーム</Link>
            <i className="ri-arrow-right-s-line text-[#C0B8B0]" />
            <span className="text-[#6B6B6B]">{title}</span>
          </nav>
          <h1 className="text-2xl md:text-3xl font-bold text-[#2C2C2C] mb-3">{title}</h1>
          {subtitle && (
            <p className="text-sm text-[#6B6B6B]">{subtitle}</p>
          )}
          {lastUpdated && (
            <p className="text-xs text-[#A0A0A0] mt-3">最終更新日：{lastUpdated}</p>
          )}
        </div>
      </div>

      {/* Content */}
      <main className="max-w-3xl mx-auto px-6 py-14">
        <div className="bg-white rounded-xl border border-[#EDE7DE] p-8 md:p-10 space-y-10">
          {sections.map((section, idx) => (
            <section key={idx}>
              <h2 className="text-base font-bold text-[#2C2C2C] border-l-4 border-[#8FA882] pl-3 mb-4">
                {section.title}
              </h2>
              {section.body && (
                <p className="text-sm text-[#555] leading-relaxed whitespace-pre-line">{section.body}</p>
              )}
              {section.items && (
                <ul className="mt-3 space-y-2">
                  {section.items.map((item, i) => (
                    <li key={i} className="flex items-start gap-2 text-sm text-[#555] leading-relaxed">
                      <span className="mt-1.5 w-1.5 h-1.5 rounded-full bg-[#8FA882] shrink-0" />
                      {item}
                    </li>
                  ))}
                </ul>
              )}
            </section>
          ))}
        </div>

        {/* Back link */}
        <div className="mt-8 text-center">
          <Link
            to="/"
            className="inline-flex items-center gap-2 text-sm text-[#8FA882] hover:text-[#7A9570] transition-colors cursor-pointer"
          >
            <i className="ri-arrow-left-line" />
            トップページへ戻る
          </Link>
        </div>
      </main>

      <Footer />
    </div>
  );
}
